// DatabaseObject properties
export const DataKeys = {
  OVERVIEW: 'overview',
  LITERATURE_REFERENCE: 'literatureReference',
  REFERENCE_ENTITY: 'referenceEntity',
  CROSS_REFERENCE: 'crossReference',
  AUTHORED: 'authored',
  REVIEWED: 'reviewed',
  EDITED: 'edited',
  REVISED: 'revised',
  CREATED: 'created',
  MODIFIED: 'modified',
  EVENTS: 'events',
  INPUT: 'inputs',
  OUTPUT: 'outputs',
  CATALYST_ACTIVITY: 'catalystActivity',
  CATALYST_ACTIVITY_REFERENCE: 'catalystActivityReference',
  OTHER_FORMS: 'otherForms',
  INFERRED_TO: 'inferredTo',
  SUMMATION: 'summation',
  CATEGORY: 'category',
  CLASS_NAME: 'className',
  SPECIES_NAME: 'speciesName',
  COMPARTMENT: 'hasCompartment',
  NAME: 'name',
  DISPLAY_NAME: 'displayName',
  TISSUE: 'tissue',
  REVIEW_STATUS: 'reviewStatus',
  PUBLICATION: 'publication',
  INTERACTORS: 'interactors',
  AUTHORSHIP: 'authorship',
  INFERRED_FROM: 'inferredFrom',
  PRECEDING_EVENT: 'precedingEvent',
  FOLLOWING_EVENT: 'followingEvent',
  COMPONENTS: 'components',
  INPUT_FOR: 'inputFor',
  OUTPUT_FOR: 'outputFor',
  REGULATED_BY: 'regulatedBy',
  REGULATION_REFERENCE: 'regulationReference',
  MODIFIED_RESIDUES: 'modifiedResidues',
  MEMBERS: 'members',
  CANDIDATES: 'candidates',
  IN_DISEASE: 'inDisease',
  DISEASE: 'disease',
  RNA_MARKERS: 'rnaMarker',
  PROTEIN_MARKER: 'proteinMarker',
  MARKER_REFERENCE: 'markerReference',
  REPEATED_UNIT: 'repeatedUnits',
  CELL_TYPE: 'cellType',
  ORGAN:'organ',
  TISSUE_LAYER:'tissueLayer',
  IDENTIFIER: 'identifier',


} as const;


// Labels
export const Labels = {
  OVERVIEW: 'Overview',
  AUTHOR: 'Author',
  REVIEWER: 'Reviewer',
  EDITOR: 'Editor',
  REVISER: 'Reviser',
  CREATOR: 'Creator',
  CROSS_REFERENCES: 'Cross References',
  REFERENCE: 'References',
  EXTERNAL_REFERENCE: 'External Reference',
  AUTHORSHIP: 'Authorship',
  EVENTS: 'Events',
  INPUTS: 'Inputs',
  OUTPUTS: 'Outputs',
  CATALYST_ACTIVITY: 'Catalyst Activity',
  OTHER_FORMS: 'Other forms',
  INFERENCES: 'Inferences',
  INTERACTORS: 'Interactors',
  INFERRED_FROM: 'Inferred From',
  PRECEDING_EVENT: 'Preceding Event',
  FOLLOWING_EVENT: 'Following Events',
  COMPONENTS: 'Components',
  INPUT_FOR: 'Consumed by',
  OUTPUT_FOR: 'Produced by',
  REGULATED_BY: 'Regulations',
  MODIFIED_RESIDUES: 'Modifications',
  REPEATED_UNIT: 'Repeated Units',
  MEMBERS: 'Members',
  CANDIDATES: 'Candidates',
  MARKERS: 'Markers',
} as const;

export enum SchemaClasses {
  EWAS = 'EntityWithAccessionedSequence',
  PE = 'PhysicalEntity',
  CELL = 'Cell',
  COMPLEX = 'Complex',
  DRUG = 'Drug',
  CHEMICAL_DRUG = 'ChemicalDrug',
  PROTEIN_DRUG = 'ProteinDrug',
  RNA_DRUG = 'RNADrug',
  ENTITY_SET = 'EntitySet',
  CANDIDATE_SET = 'CandidateSet',
  DEFINED_SET = 'DefinedSet',
  GENOME_ENCODED_ENTITY = 'GenomeEncodedEntity',
  OTHER_ENTITY = 'OtherEntity',
  POLYMER = 'Polymer',
  SIMPLE_ENTITY = 'SimpleEntity',



  PATHWAY = 'Pathway',
  TLP = 'TopLevelPathway',
  CELL_LINEAGE_PATH = 'CellLineagePath',
  REACTION = 'Reaction',
  BLACK_BOX_EVENT = 'BlackBoxEvent',
  POLYMERISATION = 'Polymerisation',
  DEPOLYMERISATION = 'Depolymerisation',
  FAILED_REACTION = 'FailedReaction',
  CELL_DEVELOPMENT_STEP = 'CellDevelopmentStep',
  CATALYST_ACTIVITY = 'CatalystActivity',

  REGULATION = 'Regulation',
  NEGATIVE_REGULATION = 'NegativeRegulation',
  NEGATIVE_GENE_EXPRESSION_REGULATION = 'NegativeGeneExpressionRegulation',
  POSITIVE_REGULATION = 'PositiveRegulation',
  POSITIVE_GENE_EXPRESSION_REGULATION = 'PositiveGeneExpressionRegulation',
  REQUIREMENT = 'Requirement',
  GROUP_MODIFIED_RESIDUE = 'GroupModifiedResidue',
  CROSSLINKED_RESIDUE = 'CrosslinkedResidue',
  INTER_CHAIN_CROSSLINKED_RESIDUE = 'InterChainCrosslinkedResidue',
  INTRA_CHAIN_CROSSLINKED_RESIDUE = 'IntraChainCrosslinkedResidue',

  ABSTRACT_MODIFIED_RESIDUE = 'AbstractModifiedResidue',

  MODIFIED_RESIDUE = 'ModifiedResidue',
  REPLACED_RESIDUE = 'ReplacedResidue',
  NONSENSE_MUTATION = 'NonsenseMutation',
  TRANSLATIONAL_MODIFICATION = 'TranslationalModification',

  GENETICALLY_MODIFIED_RESIDUE = 'GeneticallyModifiedResidue',
  FRAGMENT_MODIFICATION = 'FragmentModification',
  FRAGMENT_DELETION_MODIFICATION = 'FragmentDeletionModification',
  FRAGMENT_INSERTION_MODIFICATION = 'FragmentInsertionModification',
  FRAGMENT_REPLACED_MODIFICATION = 'FragmentReplacedModification',
  TRANSCRIPTIONAL_MODIFICATION = 'TranscriptionalModification',
  MODIFIED_NUCLEOTIDE = 'ModifiedNucleotide',

  REFERENCE_ENTITY = 'ReferenceEntity',
  REFERENCE_GROUP = 'ReferenceGroup',
  REFERENCE_MOLECULE='ReferenceMolecule',
  REFERENCE_SEQUENCE = 'ReferenceSequence',
  REFERENCE_RNA_SEQUENCE = 'ReferenceRNASequence',
  REFERENCE_DNA_SEQUENCE = 'ReferenceDNASequence',
  REFERENCE_GENE_PRODUCT = 'ReferenceGeneProduct',
  REFERENCE_ISOFORM = 'ReferenceIsoform',
  REFERENCE_THERAPEUTIC = 'ReferenceTherapeutic',

  LITERATURE_REFERENCE = 'LiteratureReference',
  BOOK = 'Book'


}

export enum Type {
  CANDIDATE = 'candidate',
  COMPARTMENT = 'compartment',
  COMPONENT = 'component',
  COMPONENT_OF = 'componentOf',
  ENCAPSULATED_EVENT = 'encapsulatedEvent',
  EVENT = 'event',
  MEMBER = 'member',
  MODIFIED_RESIDUE = 'modifiedResident',
  INPUT = 'input',
  OUTPUT = 'output',
  INPUT_OF = 'inputOf',
  OUTPUT_OF = 'outputOf',
  AUTHOR = 'author',
  PUBLICATION = 'publication',
  REPEATED_UNIT = 'repeatedUnit',
  REPEATED_UNIT_OF = 'repeatedUnitOf',
}
